import { render } from "./plannerdetails.vue?vue&type=template&id=1a80c7d6"
import script from "./plannerdetails.vue?vue&type=script&lang=js"
export * from "./plannerdetails.vue?vue&type=script&lang=js"

import "./plannerdetails.vue?vue&type=style&index=0&id=1a80c7d6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__